import type { LucideIcon } from "lucide-react";
import {
  Key,
  Clock,
  Users,
  Shield,
  Crown,
  Wrench,
  Trash2,
  MessageSquare,
  Send,
  CreditCard,
  CloudUpload,
} from "lucide-react";
import type { UserRole } from "@/stores/auth";

export interface AdminNavItem {
  id: string;
  label: string;
  href: string;
  icon: LucideIcon;
  roles?: UserRole[];
}

export const DEFAULT_ADMIN_PATH = "/admin/managers";

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  { id: "account-deletions", label: "Удаление аккаунтов", href: "/admin/account-deletions", icon: Trash2, roles: ["supervisor", "director", "owner"] },
  { id: "invites", label: "Инвайт-коды", href: "/admin/invites", icon: Key },
  { id: "pending", label: "Ожидающие", href: "/admin/pending", icon: Clock },
  { id: "premium-approval", label: "Согласование премиум", href: "/admin/premium-approval", icon: Crown },
  { id: "premium-production", label: "Доработка премиум", href: "/admin/premium-production", icon: Wrench },
  { id: "managers", label: "Менеджеры", href: "/admin/managers", icon: Users },
  {
    id: "supervisors",
    label: "Супервайзеры",
    href: "/admin/supervisors",
    icon: Shield,
    roles: ["director", "owner"],
  },
  {
    id: "directors",
    label: "Директоры",
    href: "/admin/directors",
    icon: Crown,
    roles: ["owner"],
  },
  {
    id: "direct-deploy",
    label: "Прямой деплой",
    href: "/admin/direct-deploy",
    icon: CloudUpload,
    roles: ["owner"],
  },
  {
    id: "users",
    label: "Все пользователи",
    href: "/admin/users",
    icon: Users,
    roles: ["director", "owner"],
  },
  { id: "groups", label: "Группы", href: "/admin/groups", icon: Shield },
  {
    id: "deletion-requests",
    label: "Удаление сайтов",
    href: "/admin/deletion-requests",
    icon: Trash2,
  },
  { id: "appeals", label: "Обращения", href: "/admin/appeals", icon: MessageSquare },
  { id: "broadcast", label: "Рассылка", href: "/admin/broadcast", icon: Send },
  { id: "billing", label: "Биллинг", href: "/admin/billing", icon: CreditCard, roles: ["supervisor", "director", "owner"] },
];

export function canAccessAdminNavItem(item: AdminNavItem, role?: UserRole) {
  if (!item.roles?.length) return true;
  return item.roles.includes(role ?? "guest");
}
